import styled from 'styled-components/macro';
import { TicketTextRegular, TicketTextBold } from '../common/fontElements';
import { lowHeightScreens, mediumScreens } from 'components/common/fontElements';
import * as colors from 'components/common/colorConstants';

export const CategoryHeadings = styled.div`
  margin: 0px;
  padding: 20px 0px;
  color: ${colors.black4};
  font-family: 'Lato-Light', sans-serif;
  font-weight: 300;
  line-height: 1.35;
  font-size: 15px;

  @media (max-width: 1500px) {
    font-size: 14px;
  }
`;

export const TypeLabel = styled.div`
  font-size: 18px;
  font-family: Lato;
  font-weight: 500;
  margin: 10px 0px 0px;
  color: ${colors.black4};
  padding-bottom: 15px;
  border-bottom: 1px solid ${colors.lightGray15};

  span {
    font-size: 11px;
    font-weight: bold;
  }

  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${lowHeightScreens}) {
    font-size: 14px;
    span {
      font-size: 9px;
      font-weight: bold;
    }
  }
`;

export const HeadingText = styled(TicketTextRegular)`
  white-space: normal;
  display: ${(props) => (props.hide ? 'none' : 'block')};
  padding: 0 20px;
`;

export const MacroHeadingText = styled(TicketTextRegular)`
  white-space: normal;
  display: ${(props) => (props.hide ? 'none' : 'block')};
  padding: 0px;
`;

export const BoldText = styled(TicketTextBold)`
  font-weight: 400;
  display: inline-block;
  white-space: normal;
`;

export const ContentBody = styled(TicketTextRegular)`
  white-space: normal;
  position: relative;
  color: ${colors.black4};
  font-family: 'Lato-Light', sans-serif;
  font-weight: 300;
  line-height: normal;
  margin: 0px;
  border-top: 1px solid ${colors.lightGray15};
  border-bottom: 1px solid ${colors.lightGray15};
  padding: 25px 20px;
`;

export const MacroContentSection = styled(ContentBody)`
  padding: 35px 35px 50px;
  margin: 15px 0px;
  border: 1px solid ${colors.lightGray15};
  border-radius: 4px;

  img {
    max-width: 100%;
  }
`;

export const ChatContentBody = styled(TicketTextRegular)`
  white-space: normal;
  position: relative;
  color: ${colors.black4};
  font-family: 'Lato-Light', sans-serif;
  font-weight: 300;
  line-height: normal;
  margin-bottom: 10px;
  border-bottom: 1px solid ${colors.lightGray15};
  padding: 10px 30px 20px;
  margin-left: auto;
  margin-right: auto;
`;

export const PageContentWrapper = styled.div`
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const PreformattedText = styled.span`
  white-space: pre-wrap;
`;
